import { RANDOM_NUMBER } from '../ramdomKey';

export const SUFFIXE_MAIL_DEFAULT = 'changez-pour-votre-mail.monmail';

export const generateEleveUserName = firstname =>
  firstname.toLowerCase().replace(/\s/g, '') + RANDOM_NUMBER();

interface GenerateProfUserName {
  firstname: string;
}

export const generateProfUserName = ({ firstname }: GenerateProfUserName) =>
  firstname + '-' + RANDOM_NUMBER();

export const generateMailIfNone = (email, userName) => {
  let formatedMail = email ? email : userName + '@' + SUFFIXE_MAIL_DEFAULT;
  formatedMail = formatedMail
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  return formatedMail;
};

export const generateZohoFormLink = user => {
  const defaultLink =
    'https://forms.zohopublic.eu/francechallenges1/form/Contact1/formperma/-7TJC2HwzBlIxL9RsVc_XbgGRbbnKJRkv-FlrFFnCy0?';
  const Keys = Object.keys(user);
  const Values = Object.values(user);
  const Queries = Keys.map((Key, index) => `${Key}=${Values[index]}`);
  return `${defaultLink}${Queries.join('&')}`;
};
